/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2024-01-25 09:54:41
 * @Description:
 */
import type {
    GameHistoryReponseStateType,
    JoinStateType,
    HistoryOnJoinStateType,
} from '@/socket/game/dto/index.dto';
import { asyncEmit } from '@/utils/socket';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';
export const useSpaceDice = (rootPath) => {
    const EMIT_SPACEDICE_BET = async (
        data: {
            predictionRange: number[];
            isFast: boolean;
            amount: string;
            frontID: number;
            isIn: boolean;
        },
        callback?: (res: any) => any,
    ) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        return await asyncEmit<{
            response: {
                roll_number: string;
                winAmount: number;
                [key: string]: any; // 前端将追加其它值
            };
        }>(`${rootPath}.spacedice.bet`, data);
    };


    return {
        EMIT_SPACEDICE_BET,
    };
};
